require('./bootstrap');

// LOKALNE
require('./components/jquery.autocomplete');
require('./components/jquery.playSound.js');
require('./components/jquery.sticky');
require('./components/parallaxie');
require('./components/x-editable/dist/bootstrap4-editable/js/bootstrap-editable.min.js');

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
window.Cookies = require('js-cookie/src/js.cookie');
window.Swiper = require('swiper/swiper-bundle');

require('flatpickr');
require('flatpickr/dist/l10n/pl').default.pl;

window.AOS = require('AOS');
AOS.init();

require('slick-carousel');

import Sortable, { MultiDrag, Swap } from 'sortablejs';
window.Sortable = Sortable;

import { tns } from './components/tiny-slider/src/tiny-slider';
window.tns = tns;

import anime from 'animejs';
window.anime = anime;

require('dropzone');
Dropzone.autoDiscover = false;

require('@fancyapps/fancybox');

require('starrr/dist/starrr.js');

require('./core');
require('./pwa');

window.QRCode = require('easyqrcodejs/dist/easy.qrcode.min');